<template>
  <div class="card">
    <div class="card-body">
      <div class="mb-3">
        <!-- <a-button
          type="primary"
          @click="generatePdf"
          :loading="printLoading"
          :disabled="printLoading"
        >
          <a-icon type="file-pdf" v-if="!printLoading" @click="generatePdf" />
          {{ $t("action.imprimerTab") }}
        </a-button>-->

        <a-range-picker
          :placeholder="[$t('paiement.dateDebut'), $t('paiement.dateFin')]"
          format="DD/MM/YYYY"
          v-model="dateRangeData"
          :mode="mode"
          @change="
            (val) => {
              handleDateRange(val);
            }
          "
        />
      </div>
      <!-- Legend for Facture and Reçu -->
      <div class="mb-2">
        <span class="mr-2">{{ $t("finance.legend") }}</span>
        <a-tag color="#108ee9">{{ $t("recette.factureTag") }}</a-tag>
        <a-tag color="blue">{{ $t("recette.recus") }}</a-tag>
      </div>
      <div>
        <a-table
          @change="tableChanged"
          rowKey="_id"
          :pagination="true"
          :data-source="data"
          :columns="columns"
          :loading="tableLoading"
          :scroll="{ x: 'max-content' }"
        >
          <template slot="serial" slot-scope="text, record">
            <a-tag :color="getSerialColor(record)">{{ text }}</a-tag>
            <br />
            <a-tag
              v-if="record.cancellation"
              :color="getCancellationColor(record.cancellation.type)"
              >{{ record.cancellation.type }}</a-tag
            >
          </template>
          <template slot="typeReglement" slot-scope="text, record">
            <li v-for="i in record.details" :key="i._id">
              {{ i.typeReglement }}
            </li>
          </template>

          <template slot="paymentOnWhat" slot-scope="text, record">
            <div class="d-inline" v-for="i in record.details" :key="i._id">
              <div v-if="i.fees">
                <a-tag color="blue" v-for="(value, key) in i.fees" :key="key">{{
                  formatFeeName(key,i.daily)
                }}</a-tag>
              </div>
            </div>
          </template>
          <template slot="paymentMethod" slot-scope="text, record">
            <div v-if="Array.isArray(record.paymentMethod)">
              <a-tooltip :title="$t('recette.detailsPaymentDist')">
                <a-button
                  type="primary"
                  shape="circle"
                  size="small"
                  @click="chequeDetailsModal(record)"
                  style="margin-right: 6px"
                >
                  <a-icon type="file-search" />
                </a-button>
              </a-tooltip>
              <span v-for="method in record.paymentMethod" :key="method">
                <template>
                  <a-tag
                    :color="getPaymentMethodColor(method)"
                    style="margin-bottom: 4px"
                  >
                    {{ $t(`recette.paymentMethod.${method}`) }}
                  </a-tag>
                </template>
              </span>
            </div>

            <div v-else>{{ text }}</div>
          </template>
          <template slot="date" slot-scope="text, record">
            {{ moment(record.date).format("DD/MM/YYYY") }}
          </template>
          <template slot="caisse" slot-scope="text, record">
            <span v-if="record.caisse">
              <a-icon type="bank" class="action-icon" />
              {{ record.caisse.name }}
              <br />
              <div class="transfer-status">
                <a-tag
                  :color="record.caisseTransfer ? 'green' : 'orange'"
                  class="transfer-tag"
                >
                  <a-icon
                    :type="
                      record.caisseTransfer ? 'check-circle' : 'clock-circle'
                    "
                    class="status-icon"
                  />
                  {{
                    record.caisseTransfer
                      ? $t("recette.transfere")
                      : $t("recette.nonTransfere")
                  }}
                </a-tag>
              </div>
            </span>
            <span v-else>--</span>
          </template>
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`${$t('paiement.chercher')} ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("scolarite.recherche") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }}</template>
          </template>
          <a-tag color="#2db7f5" slot="userName" slot-scope="text, record">
            {{ record.doneBy.userName }}
          </a-tag>
          <a-button
            slot="print"
            type="primary"
            slot-scope="text, record"
            @click="() => print(record)"
          >
            <a-icon type="file-pdf" />{{ $t("action.imprimer") }}
          </a-button>
          <a-button
            slot="annulation"
            type="danger"
            :loading="loadingAnnulation"
            :disabled="loadingAnnulation || record.status == 'cancelled'"
            slot-scope="text, record"
            @click="
              () => {
                selectedRecord = record;
                // Set default cancelType based on record type
                cancelType = record.typeFR === 'F' ? 'Avoir' : 'Annulation';
                visibleCancelModal = true;
              }
            "
          >
            <a-icon type="delete" href="javascript:;" />{{
              $t("recette.annulation")
            }}
          </a-button>
        </a-table>
      </div>
    </div>
    <chequeModal
      v-if="chequeVisible"
      :chequeVisible="chequeVisible"
      :invoiceId="invoiceId"
      @close="handleClose"
    />
    <a-modal
      v-model="visibleCancelModal"
      :title="$t('paiement.annulation')"
      @ok="annulation(selectedRecord)"
      :confirmLoading="cancelLoading"
      :okButtonProps="{ disabled: cancelLoading }"
    >
      <a-label>{{ $t("recette.type") }} : </a-label>
      <div class="text-center">
        <span class="ml-2 mr-2">{{ $t("paiement.avoir") }}</span>
        <a-switch
          v-if="!isFacture"
          :class="cancelType == 'Avoir' ? 'yellow-switch' : 'red-switch'"
          :checked="cancelType === 'Annulation'"
          :disabled="cancelLoading"
          @change="
            (val) => {
              cancelType = val ? 'Annulation' : 'Avoir';
            }
          "
        />
        <a-switch v-else :class="'yellow-switch'" :checked="false" disabled />
        <span class="ml-2 mr-2">{{ $t("paiement.annulation") }}</span>
      </div>
      <div v-if="isFacture" style="margin-top: 8px; text-align: center">
        <a-alert
          :message="$t('paiement.invoicesCanOnlyBeCredited')"
          type="info"
          show-icon
          style="margin-bottom: 16px"
        />
      </div>
      <a-label>{{ $t("paiement.note") }} : </a-label>
      <a-textarea
        v-model="cancelNote"
        :placeholder="$t('paiement.note')"
        :auto-size="{ minRows: 3, maxRows: 5 }"
        :disabled="cancelLoading"
      />
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable */
import "jspdf-autotable";
import { mapState } from "vuex";
import apiClient from "@/services/axios";
import Vue from "vue";
import VueRouter from "vue-router";
import moment from "moment";
import {
  formatFeeName as formatFeeNameUtil,
  getPaymentMethodColor,
  getSerialColor,
  getCancellationColor,
} from "@/utilities/settings";
import chequeModal from "@/components/comptabilite/chequeModal";
import { printInvoice } from "@/utilities/printInvoice";

Vue.use(VueRouter);

export default {
  props: {
    studentId: {
      required: true,
    },
    parentId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    isFacture() {
      return this.selectedRecord?.typeFR === "F";
    },
  },
  components: {
    chequeModal,
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - " + this.$t("paiement.listeReglements"),
    });
    this.nomClient = "--";
    this.getInvoices();
  },

  data() {
    return {
      loadedChequeData: null,
      dateRangeData: ["", ""],
      mode: ["date", "date"],
      fields: [
        "serial",
        "nomClient",
        "typeReglement",
        "paiementSur",
        "paymentMethod",
        "montantHT",
        "montantTotal",
        "datePaiement",
      ],
      editingKey: "",
      rowData: [],
      tableLoading: true,
      nomClient: "",
      visibleParentFile: false,
      data: [],
      parent: {},
      chequeVisible: false,
      invoiceId: "",
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      indeterminate: true,
      columns: [
        //numéro de série
        {
          title: this.$t("recette.numSerie"),
          dataIndex: "serial",
          key: "serial",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "serial",
          },
          onFilter: (value, record) =>
            record.serial.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.typeReglement"),
          dataIndex: "typeReglement",
          key: "typeReglement",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "typeReglement",
          },
          onFilter: (value, record) =>
            record.typeReglement.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.paiementQuoi"),
          dataIndex: "paymentOnWhat",
          key: "paymentOnWhat",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "paymentOnWhat",
          },
          onFilter: (value, record) => {
            let result = false;
            try {
              for (const key of Object.keys(record.fees)) {
                if (
                  this.formatFeeName(key,record.daily).toLowerCase().includes(value.toLowerCase())
                )
                  result = true;
              }
            } catch {
              result = true;
            }
            return result;
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.modePaiement"),
          dataIndex: "paymentMethod",
          key: "paymentMethod",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "paymentMethod",
          },
          onFilter: (value, record) =>
            record.paymentMethod.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.montantTTC"),
          dataIndex: "montantTotal",
          key: "montantTotal",
          sorter: (a, b) => a.montantTotal - b.montantTotal,
          customRender: (text, record) => {
            return record.montantTotal
              ? record.montantTotal.toFixed(2)
              : "0.00";
          },
        },
        {
          title: this.$t("caisse.caisse"),
          dataIndex: "caisse",
          key: "caisse",
          scopedSlots: {
            customRender: "caisse",
          },
        },
        {
          title: this.$t("recette.datePaiement"),
          dataIndex: "date",
          key: "date",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "date",
          },
          onFilter: (value, record) =>
            moment(record.date).format("DD/MM/YYYY").includes(value),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.doneBy"),
          dataIndex: "userName",
          key: "userName",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "userName",
          },
          onFilter: (value, record) =>
            record.userName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.impression"),
          dataIndex: "print",
          key: "print",
          fixed: "right",
          scopedSlots: {
            customRender: "print",
          },
        },
        {
          title: this.$t("recette.annulation"),
          dataIndex: "annulation",
          key: "annulation",
          fixed: "right",
          scopedSlots: {
            customRender: "annulation",
          },
        },
      ],
      filtredTable: [],
      filtredTableCache: [],
      printLoading: false,
      selectedRecord: null,
      visibleCancelModal: false,
      cancelType: "Annulation",
      cancelNote: "",
      loadingAnnulation: false,
      cancelLoading: false,
    };
  },
  methods: {
    formatFeeName(key, daily = false) {
      return formatFeeNameUtil(key, daily, this.$t.bind(this));
    },
    moment,
    getPaymentMethodColor,
    getSerialColor,
    getCancellationColor,
    async getInvoices() {
      await apiClient
        .get("/compV3/parent-invoice/student/" + this.studentId)
        .then((res) => {
          this.data = res.data;
          this.cacheData = this.data.map((item) => ({ ...item }));
          this.rowData = this.data.map((item) => ({ ...item }));
          this.filtredTable = this.data;
          this.filtredTableCache = this.filtredTable;
        })
        .catch()
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handleClose() {
      this.chequeVisible = false;
    },
    handleDateRange(value) {
      if (value.length == 2) {
        const start = moment(value[0]);
        const end = moment(value[1]);

        this.data = this.rowData.filter((elem) => {
          return moment(elem.date).isBetween(start, end, "days", "[]");
        });

        this.filtredTable = this.filtredTableCache.filter((elem) => {
          return moment(elem.date).isBetween(start, end, "days", "[]");
        });
      } else {
        this.data = this.rowData;
        this.filtredTable = this.filtredTableCache;
      }
    },
    chequeDetailsModal(record) {
      this.invoiceId = record._id;
      this.chequeVisible = true;
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
      this.filtredTableCache = extra.currentDataSource;
    },

    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    async print(record) {
      this.$gtag.event("Imp one multi reglement", {
        event_category: "Impression PDF",
        event_label: "ProfileEleve:listeReglement",
        value: 1,
      });
      // Reload full invoice so payment.classroom is populated (lean list
      // responses omit nested autopopulate) — needed for showClass when
      // enrollmentConfirmed is false.
      let toPrint = record;
      try {
        if (record?._id) {
          const res = await apiClient.get(
            `/compV3/parent-invoice/${record._id}`
          );
          if (res.data) toPrint = res.data;
        }
      } catch (e) {
        console.log(e);
      }
      await printInvoice(toPrint, this.settings, this.user);
    },

    annulation(record) {
      this.cancelLoading = true;

      apiClient
        .post("/compV3/parent-invoice/cancel/" + record._id, {
          type: this.cancelType,
          note: this.cancelNote,
        })
        .then((res) => {
          this.getInvoices();
          this.$message.success(this.$t("paiement.annulationSuccess"));
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.errorCode
          ) {
            this.$message.error(
              this.$t(`errorCode.${err.response.data.errorCode}`)
            );
          } else {
            this.$message.error(this.$t("error.erreur"));
          }
        })
        .finally(() => {
          this.cancelLoading = false;
          this.visibleCancelModal = false;
          this.cancelNote = "";
        });
    },
  },
};
</script>
<style scoped>
.amount-cell {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 13px;
  font-weight: 600;
  color: #262626;
}

.caisse-cell {
  font-weight: 500;
  color: #52c41a;
}
</style>
